import * as React from "react";
import classnames from "classnames";
import "./TitleRow.scss";

export interface ITitleRowProps {
    title: string;
    subtitle?: string;
    class?: string;
    onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const TitleRow = (props: React.PropsWithChildren<ITitleRowProps>): JSX.Element => {
    const onClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        props.onClick?.(e);
    };

    return (
        <div onClick={onClick} className={classnames("title-icon-wrapper", props.class)}>
            <div className="title-wrapper">
                <div className="title-row">
                    <div className="title-content-wrapper">{props.title}</div>
                </div>
            </div>
        </div>
    );
};
